/** Virtual gears (SPEC §5.2): geometric progression, default = closest to the physical ratio. */
import type { GearConfig } from './bike';

export function gearRatios(cfg: GearConfig): number[] {
  const n = Math.max(2, Math.round(cfg.count));
  const q = cfg.maxRatio / cfg.minRatio;
  return Array.from({ length: n }, (_, i) => cfg.minRatio * q ** (i / (n - 1)));
}

/** 1-based gear whose ratio is closest to the physical chainring/cog ratio. */
export function defaultGear(ratios: number[], physicalRatio: number): number {
  let best = 0;
  for (let i = 1; i < ratios.length; i++) {
    if (Math.abs(ratios[i]! - physicalRatio) < Math.abs(ratios[best]! - physicalRatio)) best = i;
  }
  return best + 1;
}

export function physicalRatio(chainring: number, cog: number): number {
  return chainring / cog;
}
